module.exports = __webpack_public_path__ + "static/media/logo.c0b4e323.svg";